<template>
  <div class="position-relative d-flex">
    <!-- 문서 리스트 -->
    <div class="w-100">
      <b-row v-for="(doc, index) in disclosure_group.documents" :key="index"
        class="d-flex justify-content-between align-items-center document-item py-3 border-bottom">
        <b-col cols="12" sm="8" xl="9">
          <h5 class="fw-600 mb-0 text-left gray-850" :style="{
            borderLeft: '4px solid ' + selected_report.main_color,
            paddingLeft: '10px'
          }" @click="doc.description != null
            && doc.description !== 'null'
            && doc.description !== 'undefined'
            && selectDoc(index)">
            {{ lang === 'KOR'
              ? doc.title
              : (doc.translated?.title_e || doc.title)
            }}
          </h5>
        </b-col>
        <b-col cols="12" sm="4" xl="3" class="d-flex justify-content-start justify-content-sm-end align-items-start mt-3 mt-sm-0">
          <div>
            <a class="cursor btn-skep mr-2" :href="print_mode ? ($store.state.static_host + doc.path) : '#'"
              @click.prevent="doc.path && downloadFile(doc.title, $store.state.static_host + doc.path)" target="_blank">
              {{ lang === 'KOR' ? '다운로드' : 'Download' }}
              <b-icon icon="download" />
            </a>
          </div>
        </b-col>


        <!-- 클릭된 문서 설명을 제목 아래에 절대 위치로 -->
        <div v-if="selectedDocIndex === index" class="doc-desc">
          <div v-html="lang === 'KOR' ? doc?.description : doc?.translated?.description_e"></div>
        </div>
      </b-row>
    </div>
  </div>
</template>

<script>
import { downloadFile } from '@/components/util.js';
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'DocumentSetSb',
  props: {
    disclosure_group: {
      type: Object,
      required: true
    },
    print_mode: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      selectedDocIndex: null
    };
  },
  computed: {
    ...mapGetters('report_list', ['selected_report']),
    ...mapState('report_list', ['lang'])
  },
  methods: {
    downloadFile,
    selectDoc(index) {
      // 이미 선택된 인덱스면 null로, 아니면 해당 인덱스로 토글
      this.selectedDocIndex = this.selectedDocIndex === index ? null : index;
    }
  }
};
</script>

<style scoped>
.title-wrap {
  white-space: normal;
  word-wrap: break-word;
  word-break: break-word;
}

/* h5 호버 효과 */
.document-item h5:hover {
  background-color: #f5f5f5;
  cursor: pointer;
}

/* 각 아이템을 기준으로 절대 배치되도록 */
.document-item {
  position: relative;
}

/* 설명 박스 */
.doc-desc {
  position: absolute;
  top: 105%;
  /* 제목/아이템 바로 아래 */
  left: 0;
  width: 100%;
  background: #fff;
  padding: 16px;
  border: 1px solid #ccc;
  border-radius: 12px;
  z-index: 10;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
</style>
